// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import ModalController from "./modal_controller"
import WordModalController from "./word_modal_controller"
import TabsController from "./tabs_controller"
import StashInputController from "./stash_input_controller"
import StashFilterController from "./stash_filter_controller"
import SortableController from "./sortable_controller"
import DropdownController from "./dropdown_controller"

application.register("hello", HelloController)
application.register("modal", ModalController)
application.register("word-modal", WordModalController)
application.register("tabs", TabsController)
application.register("stash-input", StashInputController)
application.register("stash-filter", StashFilterController)
application.register("sortable", SortableController)
application.register("dropdown", DropdownController)
